// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"7d447ab9","186":"78c0c1f2","206":"8e33fce9","588":"dcc77e01"}[chunkId] + ".chunk.js";
};